import {
  CONSENT_DESCRIPTION_OVERRIDE_SCOPE_IDS,
  groupByScopeCategory,
  getScopeAccessType,
  getScopeCategory,
  getScopeDescription,
  type ScopeAccessType,
} from '../../../common/scopeCategories'
import { type PermissionDefinition } from '../../../store/role/role'

export interface ScopeItem {
  scope: string
  label: string
  category: string
  accessType: ScopeAccessType
}

const getConsentLabel = (scopeId: string, permissionMap: Map<string, PermissionDefinition>): string => {
  const iamDescription = permissionMap.get(scopeId)?.description ?? scopeId
  return CONSENT_DESCRIPTION_OVERRIDE_SCOPE_IDS.has(scopeId) ? getScopeDescription(scopeId, iamDescription) : iamDescription
}

export const buildScopeGroups = (scopes: string[], permissions: PermissionDefinition[] = []): Map<string, ScopeItem[]> => {
  const permissionMap = new Map(permissions.map((p) => [p.id, p]))
  const items = scopes.map((scopeId) => ({
    scope: scopeId,
    label: getConsentLabel(scopeId, permissionMap),
    category: getScopeCategory(scopeId),
    accessType: getScopeAccessType(scopeId),
  }))

  return groupByScopeCategory(items, (item) => item.category)
}
